import { BigNumber } from 'ethers'

// gets the current timestamp
export default function useCurrentBlockTimestamp(): BigNumber | undefined {
  return BigNumber.from(Math.floor(Date.now() / 1000))
}
